export default __webpack_public_path__ + "img/wiewat.60fa977c.svg";